import { useNavigate } from 'react-router-dom';
import useInView from '../../../hooks/useInView';

const CommercialSection = () => {
  const navigate = useNavigate();
  const { ref: leftRef, inView: leftInView } = useInView();
  const { ref: rightRef, inView: rightInView } = useInView();

  const services = [
    { icon: 'ri-building-2-line', title: 'Commercial HVAC', desc: 'Rooftop units, split systems, and VRF systems for commercial properties.' },
    { icon: 'ri-user-settings-line', title: 'Property Managers', desc: 'Dedicated account management, priority service, and custom SLAs.' },
    { icon: 'ri-home-gear-line', title: 'Multi-Unit Residential', desc: 'Maintenance contracts for apartment buildings and HOA communities.' },
    { icon: 'ri-building-line', title: 'Builders & Developers', desc: 'New construction HVAC, plumbing, and electrical for builders.' },
  ];

  return (
    <section id="commercial" className="py-10 md:py-16 bg-gradient-to-br from-[#0C2340] to-[#1A56A0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div
            ref={leftRef}
            className={`transition-all duration-800 ease-out ${leftInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
          >
            <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Commercial Services</p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 sm:mb-6">
              Built for Property Professionals
            </h2>
            <p className="text-base sm:text-lg text-white/70 mb-6 sm:mb-8 leading-relaxed">
              Renova provides commercial HVAC, plumbing, and electrical services for property managers, builders, and commercial clients. Custom SLAs, dedicated account teams, and multi-location coordination.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => navigate('/commercial')}
                className="bg-[#C41E3A] text-white px-7 py-3.5 rounded-lg text-sm font-semibold hover:bg-[#A01830] transition-colors whitespace-nowrap cursor-pointer"
              >
                Explore Commercial Services
              </button>
              <button
                onClick={() => navigate('/contact')}
                className="border border-white/30 text-white px-7 py-3.5 rounded-lg text-sm font-semibold hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                Contact Sales Team
              </button>
            </div>
          </div>

          <div ref={rightRef} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {services.map((s, i) => (
              <div
                key={s.title}
                style={{ transitionDelay: `${i * 100}ms` }}
                className={`bg-white/8 border border-white/10 rounded-xl p-6 transition-all duration-700 ease-out ${rightInView ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'}`}
              >
                <div className="w-11 h-11 bg-white/10 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${s.icon} text-xl text-white`} />
                </div>
                <h3 className="text-sm font-bold text-white mb-2">{s.title}</h3>
                <p className="text-xs text-white/60 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommercialSection;
